<template>
    <div class="Report__field">
        <ReportFieldText v-if="field.type === 'text'" :field="field" />
        <ReportFieldTextarea v-else-if="field.type === 'textarea'" :field="field" />
        <ReportFieldWYSIWYG v-else-if="field.type === 'wysiwyg'" :field="field" />
        <ReportFieldAddress v-else-if="field.type === 'address'" :field="field" />
        <ReportFieldUpload v-else-if="field.type === 'image-upload'" :field="field" />
        <ReportFieldColorSelect v-else-if="field.type === 'color-select'" :field="field" />
        <ReportFieldFontSelect v-else-if="field.type === 'font-select'" :field="field" />
        <ReportFieldTemplateSelect v-else-if="field.type === 'template-select'" :field="field" />
        <ReportFieldSchedule v-else-if="field.type === 'schedule'" :field="field" />
        <ReportFieldGroup v-else-if="field.type === 'group'" :field="field" />
        <ReportFieldTestimonial v-else-if="field.type === 'testimonial'" :field="field" />
        <ReportFieldHeroSelector v-else-if="field.type === 'hero-selector'" :field="field" />
        <div v-else>{{field.name}} error</div>
    </div>
</template>

<script>
import ReportFieldText from '@/reports/Fields/ReportFieldText';
import ReportFieldTextarea from '@/reports/Fields/ReportFieldTextarea';
import ReportFieldWYSIWYG from '@/reports/Fields/ReportFieldWYSIWYG';
import ReportFieldAddress from '@/reports/Fields/ReportFieldAddress';
import ReportFieldUpload from '@/reports/Fields/ReportFieldUpload';
import ReportFieldColorSelect from '@/reports/Fields/ReportFieldColorSelect';
import ReportFieldFontSelect from '@/reports/Fields/ReportFieldFontSelect';
import ReportFieldTemplateSelect from '@/reports/Fields/ReportFieldTemplateSelect';
import ReportFieldSchedule from '@/reports/Fields/ReportFieldSchedule';
import ReportFieldGroup from '@/reports/Fields/ReportFieldGroup';
import ReportFieldTestimonial from '@/reports/Fields/ReportFieldTestimonial';
import ReportFieldHeroSelector from '@/reports/Fields/ReportFieldHeroSelector';
export default {
    components: {
        ReportFieldHeroSelector,
        ReportFieldTestimonial,
        ReportFieldGroup,
        ReportFieldSchedule,
        ReportFieldTemplateSelect,
        ReportFieldFontSelect,
        ReportFieldColorSelect,
        ReportFieldUpload,
        ReportFieldAddress,
        ReportFieldWYSIWYG,
        ReportFieldTextarea,
        ReportFieldText
    },
    props: {
        field: {
            type: Object,
            required: true,
        }
    },
};
</script>
<style lang="scss">
.Report__field {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.Report__field__content {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    margin-top: 12px;
}

.Report__field__content__heading {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    padding: 0 4px;
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.6) !important;
}

.Report__field__submission {
    display: flex;
    flex-flow: row nowrap;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 18px;

    .v-input {
        flex: 1 1 80%;
        width: 80%;
    }

    button {
        flex: 0 0 36px;
        width: 36px;
    }

    .v-text-field__details {
        display: none !important;
    }
}

.Report__field__group {
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.Report__field__group__field__wrapper {
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.Report__field__group__field {
    display: flex;
    flex-flow: row nowrap;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;

    &.jsAddMargin {
        margin-bottom: 12px;
    }

    .v-input {
        flex: 1 1 80%;
        width: 80%;
    }

    button {
        flex: 0 0 36px;
        width: 36px;
    }

    .v-text-field__details {
        display: none !important;
    }
}

.Report__field__image {
    position: relative;
    flex: 0 0 75px;
    width: 75px;
    height: 75px;
    margin-right: 8px;

    img {
        display: inline-block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        margin-right: 8px;

    }
}

.Report__group-field-wrapper {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}
</style>
